import Axios from 'axios';
import header from './auth/header'

const API_URL = process.env.API_URL + '/api/v3';

class Tilaka {
	updateProfileKYC(data) {
		return Axios.patch(API_URL + '/kyc-funder/update-profile', data, { headers: header() });
	}
	registerKYC() {
		return Axios.post(API_URL + '/kyc-funder/register', null, { headers: header() });
	}
	getUrlWebviewRegisterKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/webview-register', data, { headers: header() });
	}
	redirectRegisterKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/redirect-register', data, { headers: header() });
	}
	getUrlWebviewPenautanKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/webview-penautan', data, { headers: header() });
	}
	redirectPenautanKYC(data) {
		return Axios.post(API_URL + '/kyc-funder/redirect-penautan', data, { headers: header() });
	}
	
	checkKycStatus() {
		return Axios.get(API_URL + '/kyc-mitra/mitra-check', { headers: header() });
	}
	checkUrlMitraRegister(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/check-url`, data);
	}
	checkKeyMitraRegister(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/check-key`, data);
	}
	register(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/register`, data);
	}
	getUrlWebviewRegister(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/webview-register`, data);
	}
	redirectRegister(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/redirect-register`, data);
	}
	getUrlWebviewPenautan(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/webview-penautan`, data);
	}
	getUrlWebviewGantiSignature(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/webview-ganti-signature`, data);
	}
	redirectPenautan(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/${encryptedKey}/redirect-penautan`, data);
	}
	registerReEnroll(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/re-enroll/${encryptedKey}/register`, data);
	}
	getUrlWebviewRegisterReEnroll(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/re-enroll/${encryptedKey}/webview-register`, data);
	}
	redirectRegisterReEnroll(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/re-enroll/${encryptedKey}/redirect-register`, data);
	}
	getUrlWebviewPenautanReEnroll(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/re-enroll/${encryptedKey}/webview-penautan`, data);
	}
	redirectPenautanReEnroll(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-mitra/re-enroll/${encryptedKey}/redirect-penautan`, data);
	}

	// e-KYC nasabah (funder) lewat link yang digenerate admin.
	// Semua endpoint di bawah tidak memakai token: user di-resolve dari encryptedKey.
	checkUrlFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/check-url`, data);
	}
	checkKeyFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/check-key`, data);
	}
	registerFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/register`, data);
	}
	getUrlWebviewRegisterFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/webview-register`, data);
	}
	redirectRegisterFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/redirect-register`, data);
	}
	getUrlWebviewPenautanFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/webview-penautan`, data);
	}
	redirectPenautanFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/redirect-penautan`, data);
	}
	getUrlWebviewGantiSignatureFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/${encryptedKey}/webview-ganti-signature`, data);
	}
	registerReEnrollFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/re-enroll/${encryptedKey}/register`, data);
	}
	getUrlWebviewRegisterReEnrollFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/re-enroll/${encryptedKey}/webview-register`, data);
	}
	redirectRegisterReEnrollFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/re-enroll/${encryptedKey}/redirect-register`, data);
	}
	getUrlWebviewPenautanReEnrollFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/re-enroll/${encryptedKey}/webview-penautan`, data);
	}
	redirectPenautanReEnrollFunder(encryptedKey, data) {
		return Axios.post(API_URL + `/kyc-funder/re-enroll/${encryptedKey}/redirect-penautan`, data);
	}
}

export default new Tilaka();


// WEBPACK FOOTER //
// ./src/api/tilaka.js